/**
 * O novo aceite (docs/spec/termos.md): a conta aceitou uma versão anterior dos termos (ou nenhuma) e
 * precisa aceitar a atual para continuar. O aviso não fecha com Esc nem por fora: a pessoa aceita ou
 * sai da conta.
 */
import { useState } from 'react';
import { useLanguage, useT } from '../i18n/index.js';
import type { LegalDoc } from '../legal/documents.js';
import { legalDate } from '../legal/LegalDocument.js';
import { useApp } from '../store.js';
import { Button, Dialog, ErrorLabel } from '../ui/controls.js';
import { TermsDialog } from './TermsDialog.js';
import { TosConsent } from './TosConsent.js';

const stay = () => {};

export function TermsUpdateDialog() {
  const t = useT();
  const language = useLanguage((s) => s.language);
  const acceptTos = useApp((s) => s.acceptTos);
  const logout = useApp((s) => s.logout);
  const [checked, setChecked] = useState(false);
  const [missing, setMissing] = useState(false);
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState<string | null>(null);
  const [view, setView] = useState<LegalDoc | null>(null);

  async function accept() {
    if (!checked) {
      setMissing(true);
      return;
    }
    setBusy(true);
    setFailed(null);
    const problem = await acceptTos();
    setBusy(false);
    if (problem) setFailed(problem);
  }

  return (
    <>
      <Dialog
        title={t('legal.update.title')}
        onClose={stay}
        className="rd-legal__update"
        actions={
          <>
            <Button onClick={() => void logout()}>{t('legal.update.signOut')}</Button>
            <Button variant="action" busy={busy} onClick={() => void accept()}>
              {t('legal.update.accept')}
            </Button>
          </>
        }
      >
        <p>{t('legal.update.text', { date: legalDate(language) })}</p>
        <TosConsent
          checked={checked}
          onChange={(v) => {
            setChecked(v);
            if (v) setMissing(false);
          }}
          invalid={missing}
          onView={setView}
        />
        {missing ? <ErrorLabel>{t('register.error.tosRequired')}</ErrorLabel> : null}
        {failed ? <ErrorLabel>{failed}</ErrorLabel> : null}
      </Dialog>
      {view ? <TermsDialog initial={view} onClose={() => setView(null)} /> : null}
    </>
  );
}
